import React from 'react';

import { ReactComponent as Icon } from '../../../assets/ocpptag.svg';

const OcppTagIcon = ({fill}) => {
    return (
        <Icon alt="coin icon" className="coin_icon" style={{ width:'15px', fill: fill }} />
    );
};
export default OcppTagIcon;